import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Col, Container, Div, Row, Text } from '@pinpoint/design-kit';
import { Page } from 'src/containers';
import { appActions } from 'src/store/actions';
import ClientSftp from 'src/components/client_sftp';
import ClientSftpDocs from 'src/components/client_sftp_docs';
import ClientSftpFiles from 'src/components/client_sftp_files';

function ClientSftpList({ tenant, clientName, enqueueNotification }) {
  const [username, setUsername] = useState('');
  const [allowed, setAllowed] = useState(false);

  return (
    <Container w="100%" minW="100%">
      <Row>
        <Col size="12">
          <Div d="flex" align="center" justify="space-between" p={{ l: '3.25rem', r: '3.25rem', t: '1.5rem' }}>
            <Text textSize="small" textColor="navyBlue">
              {clientName ? `SFTP for ${clientName}` : 'SFTP for the selected client'}
            </Text>
            <Div d="flex" align="center">
              <ClientSftp
                variant="login"
                tenant={tenant}
                clientName={clientName}
                enqueueNotification={enqueueNotification}
                onLoaded={(data) => {
                  setAllowed(!!(data && data.enabled));
                  setUsername((data && data.transferUserName) || '');
                }}
              />
              <ClientSftpDocs username={username} />
            </Div>
          </Div>
          {allowed ? (
            <ClientSftpFiles tenant={tenant} enqueueNotification={enqueueNotification} />
          ) : (
            <Text textSize="small" p={{ l: '3.25rem', t: '1.5rem' }}>
              SFTP is turned off for this client. Allow it from the client page.
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = ({ app }) => ({
  tenant: app.tenant,
  clientName: app.client && app.client.name,
});

const mapDispatchToProps = (dispatch) => ({
  enqueueNotification: (...params) => dispatch(appActions.enqueueNotification(...params)),
});

ClientSftpList.propTypes = {
  tenant: PropTypes.string,
  clientName: PropTypes.string,
  enqueueNotification: PropTypes.func.isRequired,
};

ClientSftpList.defaultProps = {
  tenant: '',
  clientName: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(Page(ClientSftpList));
